// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__m7+fr","left":"Header_left__XI1Yl","right":"Header_right__S+Hzt","icon":"Header_icon__POIbH"};